import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { hideLoyaltyModal } from 'stores/reducers/loyalty-modal';
import omit from 'utils/omit';
import styles from './ModalLoyalty.module.scss';

function ModalLoyalty({ loyaltyUrl }) {
  const router = useRouter();
  const dispatch = useDispatch();
  const { isShowing } = useSelector((state) => state.loyaltyModal);
  const closeModal = useCallback(() => {
    dispatch(hideLoyaltyModal());
    if (router.query.showModal) {
      router.push(
        `?${new URLSearchParams(omit(router.query, 'showModal'))}`,
        undefined,
        { shallow: true }
      );
    }
  }, [dispatch, router]);
  return (
    <Modal
      show={isShowing}
      contentClassName={`${styles.loyaltyContent}`}
      onHide={closeModal}
    >
      <Modal.Body className={`${styles.loyaltyBody}`}>
        {/* eslint-disable-next-line react/iframe-missing-sandbox */}
        <iframe title="sbj" src={loyaltyUrl} height="100%" width="100%" />
        <div className={styles.closeHeader}>
          <Button
            variant="none"
            className={styles.closeBtn}
            onClick={closeModal}
          >
            <span className={classNames('d-inline-block', styles.close)}>
              <FontAwesomeIcon icon={faXmark} />
            </span>
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default memo(ModalLoyalty);
